<template>
  <div class="card mb-4 optimiza-table">
    <div v-if="title" class="card-header pb-0 ps-3">
      <h6 class="text-lg font-weight-bolder">{{ title }}</h6>
    </div>
    <div class="card-body p-1">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center my-2">
          <thead>
            <tr>
              <th
                v-for="(columna, index) in normalizedCabecera"
                :key="`header-${index}`"
                class="text-uppercase text-analiza-dark text-base font-weight-bolder opacity-8 ps-2 py-1"
                :class="{ 'ps-2': index > 0 , 'text-center': index > 0 }"
              >
                {{ columna }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr
                v-for="fila in skeletonRows"
                :key="`skeleton-row-${fila}`"
              >
                <td
                  v-for="columna in skeletonColumns"
                  :key="`skeleton-cell-${fila}-${columna}`"
                  class="px-3 py-3"
                >
                  <span
                    class="optimiza-table-skeleton"
                    :class="{ 'optimiza-table-skeleton-short': columna === 1 }"
                  ></span>
                </td>
              </tr>
            </template>
            <template v-else-if="normalizedLineas.length">
              <tr
                v-for="(linea, rowIndex) in normalizedLineas"
                :key="`row-${rowIndex}`"
              >
                <td
                  v-for="(columna, columnIndex) in normalizedCabecera"
                  :key="`cell-${rowIndex}-${columnIndex}`"
                  class="px-3 py-2"
                >
                  <!-- eslint-disable vue/no-v-html -->
                  <div
                    class="text-sm font-weight-bold mb-0"
                    :class="{ 'text-center': columnIndex > 0 }"
                    v-html="formatCell(linea[columnIndex])"
                  ></div>
                  <!-- eslint-enable vue/no-v-html -->
                </td>
              </tr>
            </template>
            <tr v-else>
              <td
                class="text-center py-4"
                :colspan="normalizedCabecera.length || 1"
              >
                <span class="text-sm text-muted">Sin datos</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OptimizaTable",
  props: {
    title: {
      type: String,
      default: "",
    },
    cabecera: {
      type: Array,
      default: () => [],
    },
    lineas: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedCabecera() {
      return Array.isArray(this.cabecera) ? this.cabecera : [];
    },
    normalizedLineas() {
      if (!Array.isArray(this.lineas)) {
        return [];
      }

      return this.lineas.map((linea) => {
        return Array.isArray(linea) ? linea : [linea];
      });
    },
    skeletonColumns() {
      return Math.max(this.normalizedCabecera.length, 1);
    },
    skeletonRows() {
      return 4;
    },
  },
  methods: {
    formatCell(value) {
      if (value === null || value === undefined) {
        return "";
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.optimiza-table {
  background-color: var(--bs-gray-200);
  tr, th {border-bottom: 1px solid white!important;}
}
.optimiza-table :deep(.circulo-verde) {
  width: 12px;
  height: 12px;
  background-color: green;
  border-radius: 100%;
  display: block;
}
.optimiza-table :deep(.circulo-ambar) {
  width: 12px;
  height: 12px;
  background-color: orange;
  border-radius: 100%;
  display: block;
}
.optimiza-table :deep(.circulo-rojo) {
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 100%;
  display: block;
}
.optimiza-table-skeleton {
  position: relative;
  display: block;
  width: 100%;
  height: 1rem;
  overflow: hidden;
  border-radius: 0.35rem;
  background: #e9ecef;

  &::after {
    position: absolute;
    inset: 0;
    content: "";
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.75) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: optimiza-table-skeleton-shimmer 1.25s infinite;
  }
}

.optimiza-table-skeleton-short {
  width: 70%;
}

@keyframes optimiza-table-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
